export default "__VITE_ASSET__BjFlrjQz__"